import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import {Box} from '@mui/material'

import PreformattedDiv from '../../styledComponents/PreformattedDiv'
import {StyledSecondaryButton} from '../../styledComponents/Button'
import styled from 'styled-components'
import NotInterestedIcon from '@mui/icons-material/NotInterested'
import {Colors} from '../../styledComponents/Constants'
import {WideMainContainer} from '../../styledComponents/ContentsArea'
import withStyles from '@mui/styles/withStyles'

interface Props {
}

interface State {
}

class ResidentUnitOwnerConfirmationErrorPage extends Component<Props & ResidentPagePropsSet, State> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
    }

    render(): ReactNode {
        const title = 'ご利用いただけませんでした。'
        const message = '以下の原因が考えられます。\n' +
            '・確認用二次元コードがログインした部屋に対応していない\n' +
            '・確認用二次元コードが古い\n\n' +
            'ご利用になった用紙をご確認のうえ、もう一度操作してください。それでも解決できない場合は、お問い合わせください。'
        return <>
            <ContentArea>
                <ErrorTitleArea>
                    <StyledNotInterestedIcon/>
                    <ErrorTitle>
                        {title}
                    </ErrorTitle>
                </ErrorTitleArea>
                <Box height={'32px'}/>
                <WhiteArea>
                    <PreformattedDiv>{message}</PreformattedDiv>
                </WhiteArea>
                <Box height={'60px'}/>
                <StyledSecondaryButton
                    onClick={() => this.props.navigate('/resident/mypage')}
                >
                    ホームへ戻る
                </StyledSecondaryButton>
                <Box height={'15px'}/>
            </ContentArea>
        </>
    }
}

export default createResidentPage(ResidentUnitOwnerConfirmationErrorPage)

const ContentArea = styled.div`
  margin: auto;
  padding: 15px 0;
  max-width: 738px;
`

const ErrorTitleArea = styled.div`
  display: flex;
  align-items: center;
`

const StyledNotInterestedIcon = withStyles({
    root: {
        fontSize: '48px',
        color: '#b0b0b0',
    },
})(NotInterestedIcon)

const ErrorTitle = styled.div`
  margin-left: 8px;
  font-size: 20px;
  font-weight: bold;
  color: ${Colors.AccentDark};
`

const WhiteArea = styled(WideMainContainer)`
  padding: 15px;
`
